import { useEffect } from 'react';
import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchCustomerDetail } from '#/api/crmMgmt/customer/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import CustomerBlock from '#/modules/crmMgmt/customer/components/CustomerBlock';
import { getCustomerApiErrorMessage } from '#/modules/crmMgmt/customer/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { customerDetailQueryKey } from '#/utils/queryKeys';
import { toast } from '#/utils/toast';

const CustomerDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: customerDetailQueryKey(id),
    queryFn: () => fetchCustomerDetail(id),
    enabled: Boolean(id),
  });

  useEffect(() => {
    if (!detailQuery.isError) {
      return;
    }
    toast.error(getCustomerApiErrorMessage(detailQuery.error, '載入客戶失敗'));
  }, [detailQuery.isError, detailQuery.error]);

  const detail = detailQuery.data?.data;
  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">客戶詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.customer}>返回列表</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getCustomerApiErrorMessage(detailQuery.error, '載入客戶失敗')}
            </p>
          ) : null}

          {detail ? (
            <CustomerBlock
              detail={detail}
              showActions
              onRefetch={() => detailQuery.refetch()}
            />
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default CustomerDetailPage;
